<div class="step cursor-pointer" (click)="onNoClick()">
  <mat-icon class="close-icon">close</mat-icon>
</div>
<div class="step-container">
  <div class="assessment_mt-25">
    <div class="heading">
      {{ data?.message }}
    </div>
  </div>
  <mat-dialog-content class="exams-dialog setup">
    <div class="exams-box assessment_pt-20">
      <div
        class="exam-box {{
          conditionCheckForSelectedExam(i) ? 'selected' : ''
        }}"
        *ngFor="let i of searchIndices"
        (click)="saveIndex(i)"
      >
        <img
          class="icon-24 assessment_mr-8 mid-img"
          [src]="exams[i]?.image"
          alt=""
        />
        <div>
          <div class="exam-name">
            {{ exams[i]?.name }}
          </div>
          <div class="exam-desc">
            {{ exams[i]?.description }}
          </div>
        </div>
        <img
          src="{{
            conditionCheckForSelectedExam(i) ? greenTickPath : greyTickPath
          }}"
          class="ml-auto mid-img"
        />
      </div>
    </div>
  </mat-dialog-content>
  <div
    class="m-bottom-btn d-flex justify-content-md-end assessment_mt-25"
    *ngIf="data?.isExamEdit"
  >
    <button
      type="button"
      class="btn btn-primary btn-save-details cnf-btn"
      (click)="onConfirmClick()"
    >
      CONFIRM
    </button>
    <!-- <button type="button" style="color: #0C9968;" class="ASM_no-box-shadow btn btn-link assessment_mb-0 assessment_pr-30 assessment_pl-30" (click)="onNoClick()">Cancel</button> -->
    <button
      type="button"
      *ngIf="!data?.setupAccountImposed"
      class="btn btn-link assessment_mb-0 assessment_pr-30 assessment_pl-30 edit-pref-btn"
      (click)="navigateToEditProfile()"
    >
      EDIT PREFERENCES
    </button>
  </div>
</div>
